export const formData = {
  name:{
    value: null,
    error: false,
    isVisited: false,
    isRequired: true,
    isValid: false,
    config:{
      id:'name',
      type:'text',
      fullWidth: true,
      label:'Nombre',
      placeholder:'Ingrese un nombre',
      helper:'Nombre no válido'
    },
    rules:{
      type:'distance',
      min:1,
      max:100
    }
  },
  email:{
    value: null,
    error: false,
    isVisited: false,
    isRequired: true,
    isValid: false,
    config:{
      id:'email',
      type:'text',
      fullWidth: true,
      label:'Email',
      placeholder:'Ej. -> test@test.com',
      helper:'Email no válido'
    },
    rules:{
      type:'email',
    }
  },
}